<template>
    <el-dialog class="forget-password dialog-w420" :close-on-click-modal="false" :close-on-press-escape="false" @before-close="cancel" :append-to-body="true" :visible.sync="forgetVisible">
         <div class="dialog-title">忘记密码</div>
        <div class="input-item">
            <input type="text" v-model="phonenum" maxlength="11" name="phone"  placeholder="请输入手机号" autocomplete="false"/>
        </div>
        <div class="input-item">
            <input type="text" class="note-code" v-model="notecode" name="notecode" placeholder="请输入短信验证码" autocomplete="false"/>
            <span class="send-code" @click="getcode">{{codeText}}</span>
        </div>
        <div class="input-item">
            <input type="password" v-model="newpwd" maxlength="16" name="pwd" placeholder="请输入新密码" autocomplete="false"/>
        </div>
        <div class="input-item">
            <input type="password" v-model="confirmpwd" maxlength="16" name="pwd" placeholder="请确认新密码" autocomplete="false"/>
        </div>
        <div class="btn-multi">
            <a href class="default" @click.prevent="cancel">取消</a>
            <a href class="primary" @click.prevent="submit">提交</a>
        </div>
    </el-dialog>
</template>
<script>
    import {getSMSCode} from '@/api/login.js'
    import {setStore, getStore, removeStore} from '@/utils/utils.js'
    import regExp from '@/config/regExp.js'
    export default {
        data() {
            return {
                tipText: '',
                forgetVisible: false,
                currTab: 0,
                phonenum: '',
                notecode: '',
                newpwd: '',
                confirmpwd: '',
                codeText: '发送验证码'
            }
        },
        watch: {
            tipText(value) {
                if (value) {
                    this.$message({
                        type: 'warning',
                        message: value
                    })
                }
                this.tipText = ''
            }
        },
        mounted() {
            let ct = getStore('loginCurrTab');
            if ( ct == 1) {
                this.currTab = 1;
            }
            removeStore('loginCurrTab');
        },
        methods: {
            cancel() {
                this.forgetVisible = false
                this.phonenum = ''
                this.notecode = ''
                this.newpwd = ''
                this.confirmpwd = ''
                this.codeText = '发送验证码'
                clearInterval(this.stid)
            },
            submit() {
                if (!this.phonenum.trim()) {
                    return this.tipText = '请输入手机号'
                }
                if (!regExp.REG_PHONE.test(this.phonenum.trim())) {
                    return this.tipText = '手机号格式不正确'
                }
                if (!this.notecode.trim()) {
                    return this.tipText = '请输入验证码'
                }
                if (!this.newpwd.trim()) {
                    return this.tipText = '请输入新密码'
                }
                if (!this.confirmpwd.trim()) {
                    return this.tipText = '请确认新密码'
                }
                if (this.newpwd !== this.confirmpwd) {
                    return this.tipText = '两次输入密码不一致'
                }
            },
            getcode(e) {
                let target = e.target || e.srcElement;
                if (~target.className.indexOf('dis')) {
                    return;
                }
                if (!this.phonenum.trim()) {
                    return this.tipText = '请输入手机号'
                }
                if (!regExp.REG_PHONE.test(this.phonenum.trim())) {
                    return this.tipText = '手机号格式不正确'
                }
                getSMSCode({
                    mobilePhone: this.phonenum,
                    codeType: 'SMS_RESET_PASSWORD_CODE'
                }).then((res) => {
                    if (res.data.code === 1000) {
                        let count = 59;
                        let _this = this
                        this.stid = setInterval(function() {
                            target.innerText = count + 'S';
                            target.className = 'send-code dis';
                            count--;
                            if (count < 0) {
                                _this.codeText = '重新发送';
                                clearInterval(this.stid);
                                target.className = 'send-code';
                            }
                        },
                        1000);
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.message
                        });
                    }
                }, (error) => {
                    console.log(error);
                });
            },
        },
    }
</script>
<style lang="scss">
// 登录/修改密码/忘记密码/实名认证弹窗
@function rem ($px) {
    @return $px + px;
}
@mixin lhcf($height, $color, $fz) {
    height: rem($height);
    line-height: rem($height);
    color: $color;
    font-size: rem($fz);
}
@mixin lhcfc($height, $color, $fz) {
    height: rem($height);
    line-height: rem($height);
    color: $color;
    font-size: rem($fz);
    text-align: center;
}
.dialog-w420 {  
    .el-dialog {
        width: 420px;
        padding: 0;
        background-color: #fff;
        border-radius: 5px;
    }
    .dialog-title {
        font-size: 22px;
        color: #333;
        text-align: center;
        padding-top: 40px;
    }
    .el-dialog__header {
        padding: 0;
    }
    .el-dialog__body {
        padding: 0 50px;
    }
    .el-dialog__headerbtn {
        top: 5px;
        right: 10px;
        font-size: 22px;
    }
    .input-item {
        padding-top: 30px;
        position: relative;
        input {
            width: 100%;
            @include lhcf(44, #666, 14);
            outline: none;
            border-radius: 4px;
            padding: 0 10px;
            box-sizing: border-box;
            border: 1px solid #e3e3e3;
            &::placeholder {
                color: #b2b2b2;
            }
        }
        .note-code {
            width: 200px;
        }
        span {
            @include lhcfc(44, #333, 14);
            width: 106px;
            display: inline-block;
            cursor: pointer;
            position: absolute;
            right: 0;
            bottom: 0;
            border: 1px solid #e3e3e3;
            box-sizing: border-box;
            border-radius: 4px;
            &.dis {
                color: #b2b2b2;
                cursor: default;
            }
        }
    }
    .btn-single {
        text-align: center;
        padding: 30px 0;
        a {
            display: block;
            @include lhcf(44, #fff, 18);
            border-radius: 3px;
            background: linear-gradient(to right, lighten(#0092ff, 6%), darken(#0092ff, 6%));
        }
    }
    .btn-multi {
        text-align: center;
        padding: 30px 0;
        display: flex;
        justify-content: space-between;
        .default {
            width: 140px;
            display: block;
            @include lhcf(44, #0092ff, 18);
            border-radius: 3px;
            background: #fff;
            border: 1px solid #0092ff;
            
        }
        .primary {
            width: 140px;
            display: block;
            @include lhcf(44, #fff, 18);
            border-radius: 3px;
            background: linear-gradient(to right, lighten(#0092ff, 6%), darken(#0092ff, 6%));
        }
    }
}
</style>
